import React from "react";
import {
  Button,
  makeStyles,
  Typography,
  ClickAwayListener,
  IconButton,
  Icon,
} from "@material-ui/core";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import InfoIcon from '@material-ui/icons/Info';
import { get } from "lodash";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import { Item, SubItem } from "../../Types/Types";

export const useStyles = makeStyles(
  (theme) => ({
    productItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      cursor: "pointer",
      height: 300,
      position: "relative",
      "& img": {
        width: 250,
      },
    },
    varieties: {
      flexDirection: "column",
      position: "absolute",
      display: "flex",
      bottom: 50,
    },
    variety: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      width: 100,
      fontWeight: "bold",
      textTransform: "none",
      fontSize: 14,
      height: 38,
      "&:hover": {
        background: theme.palette.primary.main,
      },
    },
    pdfbutton: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      borderRadius: 0,
      padding: '6px',
      height: 38,
      "&:hover": {
        background: theme.palette.primary.main,
      },
    },
    buttonBlock: {
      marginBottom: 10,
    }
  }),
  { name: "CustomProductItem" }
);

export interface ProductItemProps {
  item: Item;
  loadArticle: (id: string) => void;
  selectedProduct: Item | SubItem;
  setSelectedProduct: (identifier: string) => void;
}

const ProductItem = (props) => {
  const classes = useStyles();
  const { item, loadArticle, selectedProduct, setSelectedProduct } = props;
  const subCategories = get(item, "subCategories", []);
  const basePath = getConf('routingBasePath', '');
  const products = subCategories.length > 0 ? subCategories : [item];
  const identifiers =
    subCategories.length > 0
      ? products.map((p) => p.identifier)
      : [item.identifier];

  const mensVariety = products.find(
    (product) =>
      product.title.toLowerCase() === "m" || product.title.toLowerCase() === "mns" || product.title.toLowerCase() === "men"
  );
  const womensVariety = products.find(
    (product) =>
      product.title.toLowerCase() === "l" || product.title.toLowerCase() === "wms" || product.title.toLowerCase() === "wmn"
  );
  const childrenVariety = products.find(
    (product) =>
      product.title.toLowerCase() === "k" || product.title.toLowerCase() === "jr"
  );
  const unisexVariety = products.find(
    (product) =>
      product.title.toLowerCase() === "u" || product.title.toLowerCase() === "all" || product.title.toLowerCase() === "uni"
  );

  const onLoadArticle = (product) => {
    loadArticle(product);
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        identifiers.includes(selectedProduct) && setSelectedProduct(null);
      }}
    >
      <div
        className={classes.productItem}
        onClick={() => setSelectedProduct(item.identifier)}
      >
        <img src={item.imageUrl} />
        {identifiers.includes(selectedProduct) && products.length > 0 && (
          <div className={classes.varieties}>
            {mensVariety && (
              <div className={classes.buttonBlock}>
                <Button
                  className={classes.variety}
                  onClick={() => onLoadArticle(mensVariety.identifier)}
                >
                  {t("overview.mens")}
                </Button>
                {get(mensVariety, 'pdfPath', null) && <IconButton
                  classes={{
                    root: classes.pdfbutton,
                  }}
                  onClick={() => window.open(basePath + mensVariety.pdfPath)}
                  >
                  <InfoIcon />
                </IconButton>}
              </div>
            )}
            {womensVariety && (
              <div className={classes.buttonBlock}>
                <Button
                  className={classes.variety}
                  onClick={() => onLoadArticle(womensVariety.identifier)}
                >
                  {t("overview.ladies")}
                </Button>
                {get(womensVariety, 'pdfPath', null) && <IconButton
                  classes={{
                    root: classes.pdfbutton,
                  }}
                  onClick={() => window.open(basePath + womensVariety.pdfPath)}
                  >
                  <InfoIcon />
                </IconButton>}
              </div>
            )}
            {childrenVariety && (
              <div className={classes.buttonBlock}>
                <Button
                  className={classes.variety}
                  onClick={() => onLoadArticle(childrenVariety.identifier)}
                >
                  {t("overview.children")}
                </Button>
                {get(childrenVariety, 'pdfPath', null) && <IconButton
                  classes={{
                    root: classes.pdfbutton,
                  }}
                  onClick={() => window.open(basePath + childrenVariety.pdfPath)}
                  >
                  <InfoIcon />
                </IconButton>}
            </div>
            )}
            {unisexVariety && (
              <div className={classes.buttonBlock}>
                <Button
                  className={classes.variety}
                  onClick={() => onLoadArticle(unisexVariety.identifier)}
                >
                  {t("overview.unisex")}
                </Button>
                {get(unisexVariety, 'pdfPath', null) && <IconButton
                  classes={{
                    root: classes.pdfbutton,
                  }}
                  onClick={() => window.open(basePath + unisexVariety.pdfPath)}
                  >
                  <InfoIcon />
                </IconButton>}
              </div>
            )}
          </div>
        )}
        <Typography>{item.title}</Typography>
      </div>
    </ClickAwayListener>
  );
};

export default ProductItem;
